// Library methods

// Utils
import { GET, POST } from '../../../utils/fetchWrappers';

// API URLs
import {
    API_STATIC_DATA,
    API_FETCH_UNDERLYING_MERCHANTS,
    API_GET_STATIC_INFO,
    API_AUDIT_TRAIL_STATIC,
    API_CHARGEBACK_STATIC_DATA,
} from '../../../utils/API/apiUrls';

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import * as loaderActions from '../loader/loader.actions';
import * as staticDataActions from './staticData.actions';
import * as merchantLegalEntityActions from '../../../containers/MerchantLegalEntity/redux/merchantLegalEntity.actions';

// Action Constants
import {
    GET_STATIC_DATA_REQUEST,
    FETCH_UNDERLYING_MERCHANT_STATIC_REQUEST,
    FETCH_STATIC_INFO_REQUEST,
    FETCH_AUDIT_TRAIL_STATIC_REQUEST,
    FETCH_CHARGEBACK_STATIC_DATA_REQUEST,
} from './staticData.constants';
import { takeLatest, put, call } from 'redux-saga/effects';

// Get Static Data
export function* getStaticDetails() {
    yield put(loaderActions.showLoader());
    try {
        const { data } = yield call(GET, API_STATIC_DATA);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                staticDataActions.getStaticDataSuccess(data.staticDataInfo)
            );
        } else if (data && data.errorMessage) {
            yield put(
                staticDataActions.getStaticDataError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            staticDataActions.getStaticDataError({
                error: data && data.errorMessage,
            })
        );
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchUnderlyingMerchantDetails() {
    yield put(loaderActions.showLoader());
    try {
        const { data } = yield call(GET, API_FETCH_UNDERLYING_MERCHANTS);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                staticDataActions.fetchUnderlyingMerchantStaticSuccess(
                    data.merchants
                )
            );
        } else if (data && data.errorMessage) {
            yield put(
                staticDataActions.fetchUnderlyingMerchantStaticError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            staticDataActions.fetchUnderlyingMerchantStaticError({
                error: data,
            })
        );
    }
    yield put(loaderActions.hideLoader());
}

export function* getStaticInfoDetails() {
    yield put(loaderActions.showLoader());
    try {
        const request = {};
        const { data } = yield call(POST, API_GET_STATIC_INFO, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(staticDataActions.fetStaticInfoSuccess(data));
            yield put(merchantLegalEntityActions.setStaticMerchantLegalEntity(data))
        } else if (data && data.errorMessage) {
            yield put(
                staticDataActions.fetStaticInfoError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(staticDataActions.fetStaticInfoError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchStaticDataAuditTrail(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_AUDIT_TRAIL_STATIC, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(staticDataActions.fetchAuditTrailStaticSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                staticDataActions.fetchAuditTrailStaticSuccess({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            staticDataActions.fetchAuditTrailStaticError({ error: data })
        );
    }
    yield put(loaderActions.hideLoader());
}

export function* getChargebackStaticDetails() {
    yield put(loaderActions.showLoader());
    try {
        const { data } = yield call(GET, API_CHARGEBACK_STATIC_DATA);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(staticDataActions.fetchChargebackStaticSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                staticDataActions.fetchChargebackStaticError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            staticDataActions.fetchChargebackStaticError({
                error: data && data.errorMessage,
            })
        );
    }
    yield put(loaderActions.hideLoader());
}

/**
 * WATCHER SAGA
 */
export function* staticDataSagas() {
    yield takeLatest(GET_STATIC_DATA_REQUEST, getStaticDetails);
    yield takeLatest(
        FETCH_UNDERLYING_MERCHANT_STATIC_REQUEST,
        fetchUnderlyingMerchantDetails
    );
    yield takeLatest(FETCH_STATIC_INFO_REQUEST, getStaticInfoDetails);
    yield takeLatest(
        FETCH_AUDIT_TRAIL_STATIC_REQUEST,
        fetchStaticDataAuditTrail
    );
    yield takeLatest(
        FETCH_CHARGEBACK_STATIC_DATA_REQUEST,
        getChargebackStaticDetails
    );
}
